import { DynamicForm } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { eramanCMSApi, post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";

const Content = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [resData, setResData] = useState<any>([]);
  const { openToast } = useNotification();
  const navigate = useNavigate();
  const query = useQuery();

  const getRecords = () => {
    setIsLoading(true);
    let url = `/api/get-all-food-beverage-header`;
    eramanCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setResData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setResData([]);
        setIsLoading(false);
      });
  };

  const {
    data: editBrandsById,
    isLoading: isLoadingBrands,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    getRecords();
  }, [query.get("id")]);

  console.log("BannerData", resData);

  const formFields = {
    fields: fields.fAndBContent,
    initialValues: {
      field_common_image: editBrandsById?.payload
        ? [
            {
              uid: "-1",
              name: "bannerImage.png",
              status: "done",
              url: editBrandsById?.payload?.field_common_image,
            },
          ]
        : [
            {
              uid: "-1",
              name: "bannerImage.png",
              status: "done",
              url: resData[0]?.field_common_image,
            },
          ],
    },
  };

  const onSubmit = async (
    formdata: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("formdata", formdata);
    let imageKeys: any = ["field_common_image"];
    for (const key of imageKeys) {
      try {
        let field = formdata[key];
        if (field[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            formdata[key] = res.response.data;
          }
        } else {
          formdata[key] = field[0]?.url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Product Management",
      subModule: "fAndBContent",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: resData[0]?.id || editBrandsById?.payload?.id }),
        field_common_image: formdata.field_common_image,
        ...formdata,
      },
      status: status,
    };
    console.log("payload", payload);
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoading || isLoadingBrands}
      config={formFields}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${eramanHost}/api/food-and-beverages-header-data-taxonomy-items-data-list/${resData[0]?.id}`,
          "UPDATE",
          "PATCH",
          buttonValue == "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
    />
  );
};

export default Content;
